import { render, staticRenderFns } from "./contactList.vue?vue&type=template&id=095c9651&scoped=true"
import script from "./contactList.vue?vue&type=script&lang=js"
export * from "./contactList.vue?vue&type=script&lang=js"
import style0 from "./contactList.vue?vue&type=style&index=0&id=095c9651&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095c9651",
  null
  
)

export default component.exports